import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'

export const TimerContainer = styled('div')({
  position: 'relative',
  backgroundColor: '#d4d4d3',
  width: 52,
  height: 52,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto',
})

export const Progress = styled(CircularProgress)({
  position: 'absolute',
  top: -6,
  left: -6,
  zIndex: 1,
})

export const CarIcon = styled('img')({
  width: 32,
  height: 32,
})

export const PickupBlock = styled('div')({
  width: '100%',
  padding: 6,
  paddingBottom: 12,
  boxSizing: 'border-box',
})

export const PickupText = styled('div')(({theme}) => ({
  color: theme.palette.text.primary,
  textAlign: 'center',
  fontSize: 13,
  margin: '8px 12px',
}))
